import { Loading, PrivacyContentPage } from "../../components";
import React, { useEffect, useState } from "react";

import { ITermItemResponse } from "../../services/terms/terms.interface";
import { useTerms } from "../../services/terms/terms.service";

const Landing = () => {
  const { termsData, loading } = useTerms();
  const [contentPage, setContentPage] = useState<ITermItemResponse>();

  useEffect(() => {
    if (termsData) {
      const data = termsData.terms?.find((e) => e.content?.id === "2");

      setContentPage(data);
    }
  }, [termsData]);

  if (loading) {
    return <Loading centerAll />;
  }

  return (
    <>
      {contentPage ? (
        <PrivacyContentPage content={contentPage} />
      ) : null}
    </>
  );
};

export default Landing;
